import { useTranslation } from "@refinedev/core";
import { IEInvoiceItem } from "interfaces";
import moment from "moment";
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import { capitalizeFirstLetter, formatNumber, getFormattedDate } from "utills/helpers";
import { Tag } from "components/tag";

interface EInvoiceTableProps {
  data?: IEInvoiceItem[];
  pageSize: number;
  currentPage: number;
}

export const EInvoiceTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
}: EInvoiceTableProps) => {
  const { translate } = useTranslation();

  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                {translate("no")}
              </th>
              <th scope="col" className="th">
                {translate("einvoice-no")}
              </th>
              <th scope="col" className="th">
                {translate("einvoice-date")}
              </th>
              <th scope="col" className="th">
                {translate("einvoice-buyer-name")}
              </th>
              <th scope="col" className="th">
                {translate("einvoice-total")}
              </th>
              <th scope="col" className="th">
                {translate("einvoice-status")}
              </th>
              <th scope="col" className="th w-20">
                <span className="sr-only">PDF</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((invoice, index) => (
              <tr key={invoice.reference_code}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td">
                  {invoice.invoice_series}-{invoice.invoice_number}
                </td>
                <td className="td">
                  {invoice.issued_date
                    ? getFormattedDate(invoice.issued_date)
                    : "-"}
                </td>
                <td className="td">{invoice.buyer?.name ?? "-"}</td>
                <td className="td">
                  {invoice.total_amount != null
                    ? formatNumber(invoice.total_amount)
                    : "-"}
                </td>
                <td className="td">
                  <Tag
                    text={capitalizeFirstLetter(invoice.status)}
                    type={
                      invoice.status === "issued" || invoice.status === "signed"
                        ? "green"
                        : invoice.status === "draft"
                          ? "yellow"
                          : invoice.status === "cancelled"
                            ? "pink"
                            : "blue"
                    }
                  />
                </td>
                <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  {invoice.pdf_url && (
                    <a
                      href={invoice.pdf_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-brand-500 hover:text-brand-700"
                    >
                      <DocumentDownloadIcon className="w-5 h-5" />
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
